module.exports = __webpack_public_path__ + "img/award-logo__simplified.302a179a.svg";